import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ViewContextProvider } from '../../contexts/view-context';
import { InstantCheckoutDrawerContent } from './InstantCheckoutDrawerContent';

export const InstantCheckoutDrawer = ({
  initialView,
  flowName,
}: {
  initialView: string;
  flowName: string;
}) => {
  return (
    <ViewContextProvider initialView={initialView} flowName={flowName}>
      <QueryProvider cacheKey="drawerContent">
        <InstantCheckoutDrawerContent />
      </QueryProvider>
    </ViewContextProvider>
  );
};
